/**
 * Runtime APIs the app uses without polyfilling. A browser missing one is considered below our support
 */
const requiredFeatures: Record<string, () => boolean> = {
  'Array.prototype.at': () => typeof Array.prototype.at === 'function',
  'crypto.randomUUID': () => typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function',
  // Stands in for "can parse our es2022 chunks": engines shipped lookbehind alongside es2022
  // class syntax, and regexes compile at runtime.
  'RegExp lookbehind (es2022-era engine)': () => {
    try {
      new RegExp('(?<=a)b')
      return true
    } catch {
      return false
    }
  },
}

export function getMissingBrowserFeatures(): string[] {
  return Object.entries(requiredFeatures)
    .filter(([, isSupported]) => !isSupported())
    .map(([name]) => name)
}
